export default "__VITE_ASSET__ChkVmJYW__"